import React, { useEffect } from "react";
import {
  getFontFamily,
  getRadius,
  getShadow,
} from "../utils/cssVariableMapper";

const ThankYouModal = ({ formData, onClose }) => {
  const { body, thankYou } = formData;

  const themeColor = "#177f5dff";
  const shadowClass = getShadow(body?.shadow || "none");
  const radiusClass = getRadius(body?.radius || "md");
  const fontFamily = getFontFamily(body?.font);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  // Content Defaults
  const title = thankYou?.title || "Thank You!";
  const message =
    thankYou?.message || "Your submission has been received successfully.";

  return (
    <div
      className="fixed inset-0 z-[999] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm"
      style={{ fontFamily: fontFamily }}
      onClick={onClose}
    >
      <div
        className={`
            relative w-full max-w-[500px] min-h-[350px] 
            bg-white 
            shadow-2xl shadow-slate-900/20 
            flex flex-col 
            overflow-hidden 
            transform transition-all animate-scale-in
            ${shadowClass} ${radiusClass}
        `}
        style={{ backgroundColor: body.background}}
        onClick={(e) => e.stopPropagation()}
      >
        {/* 🎨 HEADER: Dynamic Background Color */}
        <div
          className="p-8 flex flex-col items-center justify-center text-center relative transition-colors duration-300"
          style={{ backgroundColor: themeColor }}
        >
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white/70 hover:text-white bg-black/10 hover:bg-black/20 p-1.5 rounded-full transition-all"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              ></path>
            </svg>
          </button>

          {/* Title */}
          <h2 className="text-3xl font-bold text-white tracking-tight drop-shadow-sm">
            {title}
          </h2>
        </div>

        {/* ⚪ BODY */}
        <div className="bg-white flex-1 p-4 flex flex-col items-center">
          <div className="flex-1 flex items-center justify-center w-full">
            <p
              className="text-center text-lg leading-relaxed font-medium"
              style={{ color: body?.textColor || "#111827" }}
            >
              {message}
            </p>
          </div>

          {/* Footer */}
          {/* <div className="mt-6 text-center">
            <p
              className="text-[10px] uppercase tracking-widest font-bold opacity-50 select-none"
              style={{ color: body?.textColor || "#111827" }}
            >
              Powered by ContactHQ
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ThankYouModal;
